module.exports = __webpack_public_path__ + "static/media/bird_page19a.1c3017cc.png";